import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PPDAY_75: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_PPDAY_75_N,
  },
  {
    pageId: PageId.CHAT_UPSELL_PPDAY_75,
  },
  {
    pageId: PageId.UPSELL_PPDAY_75,
  },
  {
    pageId: PageId.DOWNLOAD_PPDAY_75,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
